var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_198_194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5003 12.5722L12.0003 20.0002L4.5003 12.5722C4.00561 12.0908 3.61594 11.5122 3.35585 10.8728C3.09575 10.2334 2.97086 9.54713 2.98904 8.85711C3.00721 8.16709 3.16806 7.48831 3.46146 6.86351C3.75485 6.23871 4.17444 5.68143 4.69379 5.22676C5.21314 4.77208 5.82101 4.42987 6.47911 4.22166C7.13722 4.01345 7.83131 3.94376 8.51767 4.01698C9.20403 4.0902 9.8678 4.30473 10.4672 4.64708C11.0666 4.98943 11.5885 5.45218 12.0003 6.00618C12.4138 5.4562 12.9364 4.9975 13.5354 4.65878C14.1344 4.32007 14.7968 4.10863 15.4812 4.0377C16.1657 3.96677 16.8574 4.03787 17.5131 4.24657C18.1688 4.45526 18.7743 4.79705 19.2919 5.25054C19.8094 5.70403 20.2277 6.25946 20.5207 6.88207C20.8137 7.50468 20.975 8.18106 20.9946 8.86889C21.0142 9.55671 20.8916 10.2412 20.6344 10.8794C20.3773 11.5177 19.9912 12.096 19.5003 12.5782",
    stroke: "#0FA4F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.9998 6L8.70685 9.293C8.51938 9.48053 8.41406 9.73484 8.41406 10C8.41406 10.2652 8.51938 10.5195 8.70685 10.707L9.24985 11.25C9.93985 11.94 11.0598 11.94 11.7498 11.25L12.7498 10.25C13.3466 9.65327 14.1559 9.31803 14.9998 9.31803C15.8438 9.31803 16.6531 9.65327 17.2498 10.25L19.4998 12.5",
    stroke: "#0FA4F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5 15.5L14.5 17.5",
    stroke: "#0FA4F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15 13L17 15",
    stroke: "#0FA4F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.6f1143b767ebf058b46e73ab7a57c006.svg";
export { ForwardRef as ReactComponent };